module.exports = __webpack_public_path__ + "media/1975-1893.e5d0b5cb.mp4";